import React from 'react';

import BonosColores  from 'components/Tvendo/Sale/QuotaBPartner/ReglaParametro/BonoColor/List.js';

export default function () {
  return <BonosColores  />;
}